



























import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { AccessToggleIdentifier } from '~/models/user/access-toggles'
import CUserAccessToggles from '~/components/shared/configurable/access-toggle/CUserAccessToggles.vue'
import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    CUserAccessToggles
  },
  model: {
    prop: 'show',
    event: 'input'
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    identifier: {
      type: [String, Number] as PropType<AccessToggleIdentifier>,
      required: true
    },
    userDisplayName: {
      type: String,
      default: null
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(value: boolean) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    },
    icons: () => ({
      search: faSearch
    })
  },
  beforeDestroy() {
    this.$emit('close')
  }
})
